<template>
  <div id="app">
    <Navbar></Navbar>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue';

export default {
  name: 'app',
  components: {
    Navbar
  },
  metaInfo() {
    return { 
        title: 'NUITEQ Knowledge Base'
    }
  }
};
</script>

<style>
</style>
